// eslint-disable-next-line
import React from 'react';
import { carinaFontReset } from './styleHelper';

/** Primitive supplies style and accessibility props to group
 * @param {object} passProps : object with prop key/value pairs
 * @param {object} passProps.theme : carina theme object
 * @param {boolean} passProps.isRtl : rtl || ltr
 * @param {node} passProps.children : CheckBox's to be wrapped and rendered
 * @returns {element} ul element + children
 */
const CheckBoxGroupPrimitive = ({ theme, isRtl, children, groupLabel }) => (
  <fieldset css={{ all: 'initial', border: 'none' }}>
    <legend css={{ position: 'absolute', clip: 'rect(0 0 0 0)' }}>
      {groupLabel}
    </legend>
    <ul css={getListStyles(theme, isRtl)}>{children}</ul>
  </fieldset>
);

/** Primitive supplies style and accessibility props to group
 * @param {object} passProps : object with prop key/value pairs
 * @param {object} passProps.theme : carina theme object
 * @param {boolean} passProps.inline : display inline styling
 * @param {boolean} passProps.isRtl : rtl || ltr
 * @param {node} passProps.children : CheckBox to be rendered
 * @returns {element} li element + children
 */
const CheckBoxItemWrapper = ({ theme, inline, isRtl, children }) => (
  <li css={getListItemStyles(theme, inline, isRtl)}>{children}</li>
);

export { CheckBoxGroupPrimitive, CheckBoxItemWrapper };

function getListStyles(theme, isRtl) {
  return {
    ...carinaFontReset(theme),
    boxSizing: 'border-box',
    clear: 'both',
    color: theme.font.color.base,
    display: 'block',
    fontSize: theme.font.base.size.s,
    listStyleType: 'none',
    margin: 0,
    outline: 0,
    padding: 0,
    textAlign: isRtl ? 'right' : 'left',
    width: '100%'
  };
}

function getListItemStyles(theme, inline, isRtl) {
  return {
    position: 'relative',
    padding: '0.5rem 0',
    display: inline ? 'inline-block' : '',
    [isRtl ? 'paddingLeft' : 'paddingRight']: inline ? '0.5rem' : ''
  };
}
